const computeTotalWithWeight = (total, weight) => {
  return Math.round(total * weight)
}

export {
  computeTotalWithWeight
}
